



































































import { IMenuFilterGroupsConfig } from '@/api/schema';
import { PropType } from 'vue';
import isEqual from 'lodash/isEqual';

export default {
  name: 'VMenuFilterGroups',

  props: {
    filtersListConfig: {
      type: Array as PropType<IMenuFilterGroupsConfig[]>,
      required: true
    },
    filters: {
      type: Object,
      default: (): any => ({})
    }
  },

  data(): any {
    return {
      selectedFilters: {},
      openMenu: false
    };
  },

  computed: {
    isFiltersApply(): boolean {
      return (
        !!this.filters &&
        Object.values(this.filters).some(
          (value) => Array.isArray(value) && value.length > 0
        )
      );
    }
  },

  methods: {
    handlerClickSubmitButton(): void {
      this.$emit('update:filters', { ...this.selectedFilters });
      this.$emit('submit');

      this.closeMenu();
    },
    handlerClickClearBtn(): void {
      this.resetListGroup();
      this.handlerClickSubmitButton();
    },
    checkFilters(): void {
      if (!this.openMenu) {
        if (!isEqual(this.filters, this.selectedFilters)) {
          this.selectedFilters = { ...(this.filters || {}) };
        }
      }
    },
    resetListGroup(): void {
      this.selectedFilters = {};
    },
    closeMenu(): void {
      this.openMenu = false;
    }
  }
};
